<template>
    <div
        class="position-relative"
        @keyup.esc="close"
        @keyup.tab="close"
    >
        <input-text
            ref="select"
            :name="name"
            :readonly="true"
            :placeholder="placeholder"
            :inner-label="isOpen ? '' : innerLabel"
            :disabled="disabled || options.length == 0"
            :value="selection.map(i => i.text).join(', ')"
            :is-focused="!isOpen"
            :status="status"
            :size="size"
            :background="background"
            @keyup.enter="toggleDropdown"
            @click="toggleDropdown"
        >
            <template #left>
                <slot name="left" />
            </template>

            <template #right>
                <v-icon
                    class="text-gray-dark"
                    :name="isOpen ? 'angle-up' : 'angle-down'"
                    :w="20"
                />
            </template>
        </input-text>

        <pop-up
            name="select"
            class="w-100 overflow-hidden"
            :separation="10"
            :show="isOpen"
            :arrow="false"
            placement="bottom-start"
            @hide.stop="close"
        >
            <slot name="optionsList">
                <selectable-list
                    :disabled="disabled"
                    :is-focused="isOpen"
                    :filterable="filterable"
                    :multiple="multiple"
                    :options="options"
                    :value="value"
                    :null-option="nullOption"
                    @update:value="updateSelection"
                />
            </slot>
        </pop-up>
    </div>
</template>

<script>
import InputText from "~/components/inputs/InputText"
import SelectableList from "~/components/SelectableList"
import PopUp from "~/components/PopUp"
import InputStatus from "~/components/inputs/InputStatus"

export default {
    props: {
        ...InputStatus.props,

        options: {
            type: Array,
            required: true,
        },

        placeholder: String,
        innerLabel: String,
        name: String,
        disabled: Boolean,
        multiple: Boolean,
        filterable: Boolean,
        value: {
            type: [String, Number, Array],
            default: () => [],
        },

        nullOption: String,
        size: String,
        background: String,
    },

    emits: ["update:value", "close", "popup-opened"],

    data() {
        return {
            isOpen: false,
        }
    },

    computed: {
        selection() {
            const selected = this.multiple
                ? option => this.value.includes(option.value)
                : option => this.value === option.value
            return this.options.filter(selected)
        },
    },

    methods: {
        close() {
            this.isOpen = false
            this.$emit("close")
        },

        open() {
            this.isOpen = true
            this.$emit("popup-opened")
        },

        toggleDropdown() {
            this.isOpen ? this.close() : this.open()
        },

        updateSelection(newSelection) {
            this.$emit("update:value", newSelection)
            if (!this.multiple) {
                this.close()
            }
        },
    },

    components: {
        InputText,
        SelectableList,
        PopUp,
    },
}
</script>
